if (!customElements.get('size-chart-dialog')) {

  class SizeChartDialog extends HTMLElement {

    constructor() {

      super();

      this.dialog = this.querySelector('[data-size-chart-dialog]');

      this.openButton = this.querySelector('[data-size-chart-open]');

      this.closeButton = this.querySelector('[data-size-chart-close]');

      this.unitButtons = Array.from(this.querySelectorAll('[data-size-chart-unit]'));

      this.unitTables = Array.from(this.querySelectorAll('[data-size-chart-table]'));

      this.previouslyFocused = null;
      this.tabs = Array.from(this.querySelectorAll('[data-guide-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-guide-panel]'));
      this.selectTab = (tab, focus = false) => {
        this.tabs.forEach(button => { const active = button === tab; button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1; });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.guidePanel !== tab.dataset.guideTab; if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause()); });
        if (focus) tab.focus();
        if (tab.dataset.guideTab === 'compare') this.dispatchEvent(new CustomEvent('fp:compare-open'));
      };
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault(); const tabs = this.tabs.filter(t => !t.hidden); const i = tabs.indexOf(tab);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          this.selectTab(tabs[next], true);
        });
      });



      this.open = this.open.bind(this);

      this.close = this.close.bind(this);

      this.handleDialogClick = this.handleDialogClick.bind(this);

      this.handleClose = this.handleClose.bind(this);

      this.handleUnitClick = this.handleUnitClick.bind(this);

    }



    connectedCallback() {

      if (!this.dialog || !this.openButton || !this.closeButton) return;



      this.openButton.addEventListener('click', this.open);

      this.closeButton.addEventListener('click', this.close);

      this.dialog.addEventListener('click', this.handleDialogClick);

      this.dialog.addEventListener('close', this.handleClose);

      this.dialog.addEventListener('cancel', this.handleClose);

      this.unitButtons.forEach((button) => button.addEventListener('click', this.handleUnitClick));

    }



    disconnectedCallback() {

      if (!this.dialog || !this.openButton || !this.closeButton) return;



      this.openButton.removeEventListener('click', this.open);

      this.closeButton.removeEventListener('click', this.close);

      this.dialog.removeEventListener('click', this.handleDialogClick);

      this.dialog.removeEventListener('close', this.handleClose);

      this.dialog.removeEventListener('cancel', this.handleClose);

      this.unitButtons.forEach((button) => button.removeEventListener('click', this.handleUnitClick));

    }



    open() {

      this.previouslyFocused = document.activeElement;

      this.dialog.showModal();

      document.body.classList.add('size-chart-open');

      this.closeButton.focus();

    }



    close() {

      this.dialog.close();

    }



    handleDialogClick(event) {

      if (event.target === this.dialog) this.close();

    }



    handleUnitClick(event) {

      const unit = event.currentTarget.dataset.sizeChartUnit;



      this.unitButtons.forEach((button) => {

        const isActive = button.dataset.sizeChartUnit === unit;

        button.classList.toggle('is-active', isActive);

        button.setAttribute('aria-pressed', String(isActive));

      });



      this.unitTables.forEach((table) => {

        table.classList.toggle('is-active', table.dataset.sizeChartTable === unit);

      });

    }



    handleClose() {

      document.body.classList.remove('size-chart-open');
      this.querySelectorAll('video').forEach(video => video.pause());



      if (this.previouslyFocused && document.contains(this.previouslyFocused)) {

        this.previouslyFocused.focus();

      }

    }

  }



  customElements.define('size-chart-dialog', SizeChartDialog);

}

